import { loadScript } from '@direct-frontend/stdlib';
import type { YandexKit } from '../types/YandexKit';

/*
 * Принимаемые аргументы для метода загрузки скрипта превью
 */
type LoadScriptProps = {
    src: string;
    cspNonce?: string;
};

type YandexKitWindow = Window &
    typeof globalThis & {
        yandexKit: {
            vars: Partial<{ linkHref: string }>;
            load: () => Promise<YandexKit>;
        };
    };

/*
 * Нормализует URL, убирая trailing slash и исправляя двойные слэши
 */
const normalizeUrl = (url: string): string => url.replace(/\/+$/, '').replace(/([^:]\/)\/+/g, '$1');

class SingletonPromise {
    static promise: Promise<YandexKit>;

    static createLoadPromise(props: LoadScriptProps) {
        if (!SingletonPromise.promise) {
            SingletonPromise.promise = new Promise(async (resolve, reject) => {
                try {
                    const normalizedSrc = normalizeUrl(props.src);

                    await loadScript({ crossOrigin: 'disabled', src: normalizedSrc, cspNonce: props.cspNonce });

                    const yandexKit = await (window as YandexKitWindow).yandexKit.load();

                    resolve(yandexKit);
                } catch (error) {
                    reject(
                        error instanceof Error ? error : { name: 'YandexKit load script error', message: String(error) }
                    );
                }
            });
        }

        return SingletonPromise.promise;
    }
}

export const loadYandexKit = (props: LoadScriptProps) => SingletonPromise.createLoadPromise(props);
